/**
 * @file form.js
 * Exports constants pertaining to forms.
 */

export const FORM_BUTTON_INSERT_UPDATE = 'Save';
export const FORM_BUTTON_DELETE = 'Delete';
export const FORM_MESSAGE_DELETE_CONFIRM =
  'Are you sure you want to delete this component?';
export const FORM_BUTTON_REGISTER = 'Register';
export const FORM_BUTTON_RESET_PASSWORD = 'Reset Password';
export const FORM_BUTTON_FORGOT_PASSWORD = 'Forgot Password';
export const FORM_BUTTON_LOGIN = 'Login';
export const FORM_INPUT_VALIDATION_REGEX_URL_SEGMENT = /^[a-zA-Z0-9_-]*$/;



// WEBPACK FOOTER //
// ./src/constants/form.js